import { useMemo, useState } from 'react'
import { isMobileDevice } from 'shared/src/utils/platform'
import { noop } from 'utils'

const useOnHover = () => {
  const isMobile = isMobileDevice()
  const [ isHovered, setIsHovered ] = useState(false)

  return useMemo(() => (isMobile ? {} : {
    hoverProps: {
      onMouseOver: () => setIsHovered(true),
      onMouseOut: () => setIsHovered(false),
      onFocus: noop,
      onBlur: noop
    },
    isHovered
  }), [isMobile, isHovered])
}

export default useOnHover
